export const errorHelpers = {
  maxLength: (message) => message.match(/\d+/)[0],
  isLength: (message) => message.match(/\d+/)[0],
};
